module.exports = __webpack_public_path__ + "img/product-s618-3000.d4b0b740.png";